import MainLayout from 'layouts/MainLayout';

import { RouteObject, createBrowserRouter } from 'react-router-dom';
import MainLayoutProvider from 'providers/MainLayoutProvider';
import Notification from 'pages/notifications/Notifications';

import Error404 from 'pages/error/Error404';
import Error403 from 'pages/error/Error403';
import Error500 from 'pages/error/Error500';

import SimpleSignIn from 'pages/pages/authentication/simple/SignIn';
import SimpleSignOut from 'pages/pages/authentication/simple/SignOut';
// import SimpleForgotPassword from 'pages/pages/authentication/simple/ForgotPassword';

import SidenavCollapse from 'pages/pages/layouts/SidenavCollapse';

// import Members from 'pages/Members';

import App from 'App';
import Crm from 'pages/dashboard/Crm';

import UserList from 'pages/user-list';
import AllAsset from 'pages/AllAssets';
import AllRequest from 'pages/AllRequests';
import MyDevices from 'pages/MyDevices';
import Companies from 'pages/Companies';
import MyRequests from 'pages/MyRequests';
import PendingApprovals from 'pages/PendingApprovals';
import Purchase from 'pages/Purchase';

import ProtectedRoute from 'components/routes/ProtectedRoute';
import RoleProtectedRoute from 'components/routes/RoleProtectedRoute';
import DepartmentMangement from 'pages/DepartmentMangement';
import Categories from 'pages/category';
import Profile from 'pages/Profile';
import ForgotPassword from 'pages/ForgotPassword';
import ResetPassword from 'pages/ResetPassword';
// Import UserRole type from authSlice
import type { UserRole } from 'store/authSlice';

const routes: RouteObject[] = [
  {
    element: <App />,
    children: [
      {
        path: '/',
        element: (
          <ProtectedRoute>
            <MainLayoutProvider>
              <MainLayout />
            </MainLayoutProvider>
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: <Crm />
          },
          // {
          //   path: 'apps',
          //   children: [
          //     {
          //       path: 'crm',
          //       children: [
          //         { path: 'analytics', element: <Analytics /> },
          //         { path: 'deals', element: <Deals /> },
          //         { path: 'deal-details', element: <DealDetails /> },
          //         { path: 'report-details', element: <ReportDetails /> },
          //         { path: 'leads', element: <Leads /> },
          //         { path: 'lead-details', element: <LeadDetails /> },
          //         { path: 'reports', element: <Reports /> },
          //         { path: 'add-contact', element: <AddContact /> }
          //       ]
          //     }
          //   ]
          // },
          {
            path: '/',
            children: [
              {
                path: 'notifications',
                element: <Notification />
              },

              {
                path: 'profile',
                element: <Profile />
              },
              {
                path: 'companies',
                element: (
                  <RoleProtectedRoute
                    allowedRoles={['super_user'] as UserRole[]}
                  >
                    <Companies />
                  </RoleProtectedRoute>
                )
              },
              {
                path: 'all-assets',
                element: (
                  <RoleProtectedRoute
                    allowedRoles={['super_user', 'company_admin'] as UserRole[]}
                  >
                    <AllAsset />
                  </RoleProtectedRoute>
                )
              },
              {
                path: 'categories',
                element: (
                  <RoleProtectedRoute
                    allowedRoles={['super_user', 'company_admin'] as UserRole[]}
                  >
                    <Categories />
                  </RoleProtectedRoute>
                )
              },
              {
                path: 'all-requests',
                element: (
                  <RoleProtectedRoute
                    allowedRoles={['super_user', 'company_admin'] as UserRole[]}
                  >
                    <AllRequest />
                  </RoleProtectedRoute>
                )
              },
              {
                path: 'department-management',
                element: (
                  <RoleProtectedRoute
                    allowedRoles={['super_user', 'company_admin'] as UserRole[]}
                  >
                    <DepartmentMangement />
                  </RoleProtectedRoute>
                )
              },

              {
                path: 'my-devices',
                element: <MyDevices />
              },
              {
                path: 'my-requests',
                element: <MyRequests />
              },
              {
                path: 'user-list',
                element: (
                  <RoleProtectedRoute
                    allowedRoles={['super_user', 'company_admin'] as UserRole[]}
                  >
                    <UserList />
                  </RoleProtectedRoute>
                )
              },

              {
                path: 'pending-approvals',
                element: (
                  <RoleProtectedRoute
                    allowedRoles={
                      ['manager', 'company_admin', 'super_user'] as UserRole[]
                    }
                  >
                    <PendingApprovals />
                  </RoleProtectedRoute>
                )
              },
              {
                path: 'purchase-pending',
                element: (
                  <RoleProtectedRoute
                    allowedRoles={
                      ['manager', 'company_admin', 'super_user'] as UserRole[]
                    }
                  >
                    <Purchase />
                  </RoleProtectedRoute>
                )
              },
              {
                path: 'demo',
                children: [
                  // { path: 'vertical-sidenav', element: <VerticalSidenav /> },
                  { path: 'sidenav-collapse', element: <SidenavCollapse /> }
                ]
              }
            ]
          }
        ]
      },
      {
        path: 'login',
        element: <SimpleSignIn />
      },
      {
        path: 'forgot-password',
        element: <ForgotPassword />
      },
      {
        path: 'reset-password',
        element: <ResetPassword />
      },
      {
        path: '/errors',
        children: [
          { path: '404', element: <Error404 /> },
          { path: '403', element: <Error403 /> },
          { path: '500', element: <Error500 /> }
        ]
      },
      {
        path: '/',
        children: [
          { path: 'sign-in', element: <SimpleSignIn /> },
          { path: 'sign-out', element: <SimpleSignOut /> }
        ]
      },
      {
        path: '*',
        element: <Error404 />
      }
    ]
  }
];

export const router = createBrowserRouter(routes);

export default routes;
